import { IParcelStockoutResponseProductEntry, ParcelStockoutResponseProductEntry } from "./parcel-stockout-response-product-entry";

interface IParcelStockoutResponseParcelEntry {
    parcelId: number;
    products: IParcelStockoutResponseProductEntry[];
    errors: string[];
}

export interface IParcelStockoutResponse {
    parcels: IParcelStockoutResponseParcelEntry[];

}

export class ParcelStockoutResponse {
    private _parcelId: number;
    private _stockout: ParcelStockoutResponseProductEntry[];
    private _error: string | undefined;

    public constructor(data: IParcelStockoutResponse) {
        if (data.parcels.length > 1) {
            throw new Error("Not supported");
        }

        this._parcelId = data.parcels[0].parcelId;
        this._stockout = data.parcels[0].products.map(e => new ParcelStockoutResponseProductEntry(e));
        this._error = data.parcels[0].errors.length === 0 ? undefined : data.parcels[0].errors[0];
    }

    get parcelId() {
        return this._parcelId;
    }

    get stockout() {
        return this._stockout;
    }

    get error() {
        return this._error;
    }
}
